'use client';

import SearchIcon from '@mui/icons-material/Search';
import { Box, InputAdornment, TextField } from '@mui/material';

import { FilterDropdown } from '@/components';
import { useT } from '@/hooks';

interface LeaderboardToolbarProps {
  searchQuery: string;
  setSearchQuery: (val: string) => void;
  orderBy: 'PNL' | 'VOL';
  setOrderBy: (val: 'PNL' | 'VOL') => void;
}

export const LeaderboardToolbar = ({
  searchQuery,
  setSearchQuery,
  orderBy,
  setOrderBy,
}: LeaderboardToolbarProps) => {
  const { t } = useT();

  const sortOptions = [
    { value: 'PNL', label: t('leaderboard.profit') },
    { value: 'VOL', label: t('leaderboard.volume') },
  ];

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
      <TextField
        placeholder={t('portfolio.searchPlaceholder', { defaultValue: 'Search' })}
        value={searchQuery || ''}
        onChange={(e) => setSearchQuery(e.target.value)}
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
            </InputAdornment>
          ),
        }}
        sx={{
          flex: 1,
          minWidth: 0,
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            '& fieldset': { border: 'none' },
          },
        }}
      />
      <Box sx={{ flexShrink: 0 }}>
        <FilterDropdown
          value={orderBy}
          options={sortOptions}
          onChange={(val) => setOrderBy(val as 'PNL' | 'VOL')}
          variant="plain"
          fontSize="0.9375rem"
        />
      </Box>
    </Box>
  );
};
